<template>
  <v-card>
    <v-card-title class="primary white--text">
      <v-icon>{{icon}}</v-icon>
      <h2 class="title ml-2">{{title}}</h2>
    </v-card-title>
    <v-card-text>
      <v-form ref="data" v-if="value">
        <v-row>
          <v-col cols="12" md="6">
            <v-select
              v-model="value.libro"
              :items="getLibros"
              item-text="label"
              item-value="id"
              label="Libro"
              :error-messages="errLibro"
            ></v-select>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="value.fecha"
              type="date"
              label="Fecha"
              :error-messages="errFecha"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-text-field
          v-model="value.titulo"
          label="Título"
          :error-messages="errTitulo"
        ></v-text-field>
        <!-- <v-text-field
          v-model="value.versiculo"
          label="Versículo"
          :error-messages="errVersiculo"
        ></v-text-field> -->
        <v-textarea
          v-model="value.contenido"
          label="Contenido"
          :error-messages="errContenido"
        ></v-textarea>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="error" @click="$emit('close')">
        <v-icon left>fas fa-times</v-icon>
        Cerrar
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="save()">
        <v-icon left>fas fa-save</v-icon>
        Guardar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import dayjs from 'dayjs'
import { mapGetters } from 'vuex'
export default {
  name: 'edit-matutina',
  props: ['icon', 'title', 'value'],
  computed: {
    ...mapGetters(['getLibros']),
    errLibro () {
      const errs = []
      if (!this.$v.value.libro.$dirty) return errs
      !this.$v.value.libro.required && errs.push('El libro es requerido')
      return errs
    },
    errFecha () {
      const errs = []
      if (!this.$v.value.fecha.$dirty) return errs
      !this.$v.value.fecha.required && errs.push('La fecha es requerida')
      return errs
    },
    errTitulo () {
      const errs = []
      if (!this.$v.value.titulo.$dirty) return errs
      !this.$v.value.titulo.required && errs.push('El título es requerido')
      return errs
    },
    // errVersiculo () {
    //   const errs = []
    //   if (!this.$v.value.versiculo.$dirty) return errs
    //   !this.$v.value.versiculo.required && errs.push('El versículo es requerido')
    //   return errs
    // },
    errContenido () {
      const errs = []
      if (!this.$v.value.contenido.$dirty) return errs
      !this.$v.value.contenido.required && errs.push('El contenido es requerido')
      return errs
    }
  },
  methods: {
    save () {
      this.$v.value.$touch()
      if (!this.$v.value.$invalid) {
        this.$emit('save')
      }
    },
    reset () {
      this.$refs['data'].reset()
      this.$v.$reset()
    }
  },
  mounted () {
    if (!this.value.fecha) {
      this.value.fecha = dayjs().format('YYYY-MM-DD')
    }
  },
  validations: {
    value: {
      contenido: {
        required
      },
      fecha: {
        required
      },
      libro: {
        required
      },
      titulo: {
        required
      }
      // versiculo: {
      //   required
      // }
    }
  }
}
</script>
